/**
 * Spec 229 — this component no longer renders. It publishes.
 *
 * The trail moved to the Kridt bar (`.hub-crumb`). Rendering here as well would
 * put two "where am I" signals on the same page, which is the duplication the
 * bar exists to remove. The props are unchanged so that all 21 call sites keep
 * working without an edit; `className` is accepted and ignored because the
 * element it used to style is gone.
 */
import { usePublishBreadcrumbs } from '../lib/breadcrumb-context.js';
import type { BreadcrumbItem } from '../lib/breadcrumb-context.js';

export type { BreadcrumbItem };

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  /** Accepted for source compatibility with 21 existing call sites; unused. */
  className?: string;
}

export function Breadcrumbs({ items }: BreadcrumbsProps): null {
  usePublishBreadcrumbs(items);
  return null;
}
